import {Box} from "@mui/material";
import * as React from "react";

export default function DateIcon(props: any) {
    const { sx, ...otherProps } = props;
    return (
        <Box {...otherProps} sx={{ display: "flex", alignItems: "center", gap: "4px", width:"20px", cursor:"pointer", transform: "translateX(-10px)", ...sx}}>
            <Box component="img" alt="calendar icon"
                 src="https://www.performancegolf.com/wp-content/uploads/2025/12/calendar-icon.png"/>
            <Box component="img" alt="arrow down icon"
                 src="https://www.performancegolf.com/wp-content/uploads/2025/12/arrow-down-calendar.png"/>
        </Box>
    );
}